[
  {
    "code": "BF-BAL",
    "name": "Balé"
  },
  {
    "code": "BF-BAM",
    "name": "Bam"
  },
  {
    "code": "BF-BAN",
    "name": "Banwa"
  },
  {
    "code": "BF-BAZ",
    "name": "Bazèga"
  },
  {
    "code": "BF-BGR",
    "name": "Bougouriba"
  },
  {
    "code": "BF-BLG",
    "name": "Boulgou"
  },
  {
    "code": "BF-BLK",
    "name": "Boulkiemdé"
  },
  {
    "code": "BF-COM",
    "name": "Comoé"
  },
  {
    "code": "BF-GAN",
    "name": "Ganzourgou"
  },
  {
    "code": "BF-GNA",
    "name": "Gnagna"
  },
  {
    "code": "BF-GOU",
    "name": "Gourma"
  },
  {
    "code": "BF-HOU",
    "name": "Houet"
  },
  {
    "code": "BF-IOB",
    "name": "Ioba"
  },
  {
    "code": "BF-KAD",
    "name": "Kadiogo"
  },
  {
    "code": "BF-KMD",
    "name": "Komondjari"
  },
  {
    "code": "BF-KMP",
    "name": "Kompienga"
  },
  {
    "code": "BF-KOS",
    "name": "Kossi"
  },
  {
    "code": "BF-KOP",
    "name": "Koulpélogo"
  },
  {
    "code": "BF-KOT",
    "name": "Kouritenga"
  },
  {
    "code": "BF-KOW",
    "name": "Kourwéogo"
  },
  {
    "code": "BF-KEN",
    "name": "Kénédougou"
  },
  {
    "code": "BF-LOR",
    "name": "Loroum"
  },
  {
    "code": "BF-LER",
    "name": "Léraba"
  },
  {
    "code": "BF-MOU",
    "name": "Mouhoun"
  },
  {
    "code": "BF-NAO",
    "name": "Nahouri"
  },
  {
    "code": "BF-NAM",
    "name": "Namentenga"
  },
  {
    "code": "BF-NAY",
    "name": "Nayala"
  },
  {
    "code": "BF-NOU",
    "name": "Noumbiel"
  },
  {
    "code": "BF-OUB",
    "name": "Oubritenga"
  },
  {
    "code": "BF-OUD",
    "name": "Oudalan"
  },
  {
    "code": "BF-PAS",
    "name": "Passoré"
  },
  {
    "code": "BF-PON",
    "name": "Poni"
  },
  {
    "code": "BF-SNG",
    "name": "Sanguié"
  },
  {
    "code": "BF-SMT",
    "name": "Sanmatenga"
  },
  {
    "code": "BF-SIS",
    "name": "Sissili"
  },
  {
    "code": "BF-SOM",
    "name": "Soum"
  },
  {
    "code": "BF-SOR",
    "name": "Sourou"
  },
  {
    "code": "BF-SEN",
    "name": "Séno"
  },
  {
    "code": "BF-TAP",
    "name": "Tapoa"
  },
  {
    "code": "BF-TUI",
    "name": "Tui"
  },
  {
    "code": "BF-YAG",
    "name": "Yagha"
  },
  {
    "code": "BF-YAT",
    "name": "Yatenga"
  },
  {
    "code": "BF-ZIR",
    "name": "Ziro"
  },
  {
    "code": "BF-ZON",
    "name": "Zondoma"
  },
  {
    "code": "BF-ZOU",
    "name": "Zoundwéogo"
  }
]